export const mockUploadAction = (value: any) => {
  setTimeout(() => {
    value.onSuccess({ status: "success" });
  }, 600);
};
